import { z } from 'zod';

export const aiModelDiscoveryRequestedSchema = z.object({
  category: z.string().optional(),
});

export const aiModelDiscoveryDoneSchema = z.object({
  discovered: z.number(),
  refreshed: z.number(),
  deprecated: z.number(),
  error: z.string().optional(),
});

export const aiModelTestgenRequestedSchema = z.object({
  model_id: z.string(),
  user_id: z.string().optional(),
});

export const aiModelTestgenRespondedSchema = z.object({
  ok: z.boolean(),
  image_url: z.string().url().optional(),
  error: z.string().optional(),
  latency_ms: z.number().optional(),
});

export type AiModelDiscoveryRequestedPayload = z.infer<typeof aiModelDiscoveryRequestedSchema>;
export type AiModelDiscoveryDonePayload = z.infer<typeof aiModelDiscoveryDoneSchema>;
export type AiModelTestgenRequestedPayload = z.infer<typeof aiModelTestgenRequestedSchema>;
export type AiModelTestgenRespondedPayload = z.infer<typeof aiModelTestgenRespondedSchema>;
